var map = {
	"./bg@2x.png": "080f",
	"./bg_box_gradient@2x.png": "f2b9",
	"./icon_Login@2x.png": "4688",
	"./icon_ai@2x.png": "1f21",
	"./icon_calories@2x.png": "ce6b",
	"./icon_chats@2x.png": "5290",
	"./icon_heartrate@2x.png": "d149",
	"./icon_online@2x.png": "5248",
	"./icon_refresh@2x.png": "adaa",
	"./icon_sleep@2x.png": "1e6d",
	"./icon_synchronous@2x.png": "95b5",
	"./icon_tick@2x.png": "ba25",
	"./icon_walk@2x.png": "f63f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ef1";